export const convertPayloadToQueryString = (payload) => {
  let querystring = [];
  for (let key in payload)
    if (payload.hasOwnProperty(key)) {
      querystring.push(
        encodeURIComponent(key) + "=" + encodeURIComponent(payload[key])
      );
    }
  return querystring.join("&");
};
